"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parseSessionDataAttributesFromManifest = parseSessionDataAttributesFromManifest;
exports.readSessionDataAttributesFromManifest = readSessionDataAttributesFromManifest;
/**
 * Module that provides utility functions processing M3U8 files.
 *
 * @module M3U8 utils.
 */

var EXT_X_SESSION_DATA_REGEX = '^#EXT-X-SESSION-DATA:DATA-ID=\"([^"]*)\",(?:VALUE|URI)=\"([^"]*)\"';
var EXT_INF_REGEX = '^#EXTINF.*';
var SESSION_DATA_EXPECTED_DURATION_ID = 'hudl.video.expectedDuration';
var SESSION_DATA_PERMANENT_MANIFEST_ID = 'hudl.video.permanentManifestUri';
var NEW_LINE = '\n';

/**
 *  Trys to parse a string to an int,  and if it can't returns default value.
 * @private
 */
function tryParseInt(string, defaultValue) {
  var value = defaultValue;
  if (string !== null && string.length > 0 && !isNaN(string)) {
    value = parseInt(string, 10);
  }
  return value;
}
function parseSessionDataAttributesFromManifest(response) {
  var sessionDataAttributes = {};
  var lines = response.split(NEW_LINE);
  for (var index = 0; index < lines.length; ++index) {
    var line = lines[index];
    var match = line.match(EXT_X_SESSION_DATA_REGEX);
    if (match && match.length >= 3) {
      var dataId = match[1];
      var value = match[2];
      if (dataId === SESSION_DATA_EXPECTED_DURATION_ID) {
        sessionDataAttributes.expectedDuration = tryParseInt(value, 0);
      } else if (dataId === SESSION_DATA_PERMANENT_MANIFEST_ID) {
        sessionDataAttributes.permanentManifestUri = value;
      }
    } else if (line.match(EXT_INF_REGEX)) {
      // EXT_X_SESSION_DATA_REGEX should occur before any EXTINF tags,
      //  so let's save some cpu cycles and break the loop once we hit segments.
      break;
    }
  }
  return sessionDataAttributes;
}
/**
 * Reads the session data manifest from the M3U8 file at the URI.
 *
 * Here is 2 example tags.
 *
 * #EXT-X-SESSION-DATA:DATA-ID="hudl.video.expectedDuration",VALUE="600"
 * #EXT-X-SESSION-DATA:DATA-ID="hudl.video.permanentManifestUri",URI="http://vb.hudl.com/1485/222518/366/58a394a157f0f3d39c661366/rrx1.m3u8?v=809D928A3355D408"
 *
 * @type {Object}
 */
function readSessionDataAttributesFromManifest(manifestUri) {
  return new Promise(function (resolve, reject) {
    fetch(manifestUri).then(function (response) {
      if (!response.ok) {
        return reject(response);
      }
      return response.text();
    }).then(function (response) {
      return resolve(parseSessionDataAttributesFromManifest(response));
    });
  });
}